"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.markdownPlugins = exports.markdownPluginsForTransfromMarkdown = void 0;
const remark_sub_super_1 = __importDefault(require("remark-sub-super"));
const remark_underline_1 = __importDefault(require("remark-underline"));
const react_color_text_1 = __importDefault(require("./plugins/react-color-text"));
const underlineOptions = {
    marker: '++',
};
exports.markdownPluginsForTransfromMarkdown = [remark_sub_super_1.default, [remark_underline_1.default, underlineOptions]];
exports.markdownPlugins = [...exports.markdownPluginsForTransfromMarkdown, [react_color_text_1.default, { lowercase: false }]];
//# sourceMappingURL=markdown-plugins.js.map